/* eslint-disable no-nested-ternary */
import React from "react";
import { Paragraph, Text, Link } from "components/core/Typography";
import PropTypes from "prop-types";

const ListPoint = ({
	title,
	desc,
	descLink,
	bulletPoints = true,
	noMargin = false
}) => {
	let customClass = bulletPoints ? "bullet-point" : "no-bullet-point";
	customClass += noMargin ? " no-margin" : " margin";
	return (
		<ul className={customClass}>
			<li>
				{title && <Text weight="bold">{title}</Text>}
				{desc && <Text>{desc}</Text>}
				{descLink && (
					<Paragraph last>
						{descLink.contentBefore}
						<Link
							hover
							size="standard"
							color="blue"
							className="word-break"
							href={
								descLink.phone
									? `tel:${descLink?.phone?.number}`
									: descLink.email
									? `mailto:${descLink.email}`
									: descLink.link
							}
						>
							{descLink.linkText}
						</Link>
						{descLink.contentAfter}
					</Paragraph>
				)}
			</li>
		</ul>
	);
};

ListPoint.propTypes = {
	title: PropTypes.string,
	desc: PropTypes.string,
	descLink: PropTypes.object,
	bulletPoints: PropTypes.bool,
	noMargin: PropTypes.bool
};

export default ListPoint;
